import { render, staticRenderFns } from "./pmd.vue?vue&type=template&id=41051efc&scoped=true&"
import script from "./pmd.vue?vue&type=script&lang=ts&"
export * from "./pmd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41051efc",
  null
  
)

export default component.exports